import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveProject = (
  projectId: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};
